import React from "react";
import FAQAccordion from '../FAQAccordion';

class GreatSmokyMountainsInfo extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section className="about-us pt-trip">
          <div className="container">

            <p>
              Great Smoky Mountains National Park is the most visited national park in the United States — and for good reason. Straddling the Tennessee-North Carolina border, it offers old-growth forests, cascading waterfalls, diverse wildlife, and over 800 miles of hiking trails, all with no entry fee.
            </p>
            <p>
              Unlike many western parks, the Smokies reward you at any pace. You can drive Cades Cove loop and spot black bears from your car, or challenge yourself on the 16-mile Appalachian Trail traverse from Newfound Gap to Davenport Gap. This 4-day itinerary hits the highlights on both the Tennessee and North Carolina sides.
            </p>

            <div className="xinfo-card">
              <div className="xinfo-card-body">
                <p className="xinfo-card-label">Highest Point</p>
                <h3 className="xinfo-card-title">Clingmans Dome</h3>
                <p className="xinfo-card-price">Free · 6,643 ft elevation</p>
                <p className="xinfo-card-desc">
                  The highest point in the Smoky Mountains and the highest point on the entire Appalachian Trail. Drive to the parking area and walk the steep 0.5-mile paved path to the observation tower for 360-degree views into seven states on clear days. The road is closed December through March.
                </p>
              </div>
            </div>

            <h2>Great Smoky Mountains Trip Overview</h2>
            <ul>
              <li><strong>Duration:</strong> 4 days</li>
              <li><strong>Base towns:</strong> Gatlinburg, TN or Cherokee, NC</li>
              <li><strong>Entry fee:</strong> Free (no admission charge)</li>
              <li><strong>Best months:</strong> April–June (wildflowers), October (fall foliage)</li>
              <li><strong>Drive from Atlanta:</strong> ~2.5 hours · Charlotte: ~3 hours · Nashville: ~4 hours</li>
            </ul>

            <h2>Day 1 — Arrive Gatlinburg, Sugarlands & Laurel Falls</h2>
            <p>
              Arrive in Gatlinburg and check in. Head straight into the park to Sugarlands Visitor Center to grab a trail map and check wildlife activity reports. In the afternoon, hike <strong>Laurel Falls Trail</strong> — a paved 2.6-mile round trip to the most popular waterfall in the park. Arrive early or late afternoon to beat the crowds.
            </p>
            <p>
              Finish the day on the <strong>Roaring Fork Motor Nature Trail</strong>, a one-way 5.5-mile scenic loop through old-growth forest with several small waterfalls and historic homesteads. This road is closed in winter.
            </p>

            <h2>Day 2 — Clingmans Dome & Alum Cave Trail</h2>
            <p>
              Start early for the drive up Newfound Gap Road to <strong>Clingmans Dome</strong>. The 0.5-mile walk to the observation tower is steep but short — reward yourself with panoramic Appalachian views. Then drive back down and hike <strong>Alum Cave Trail</strong> (4.4 miles round trip to Alum Cave Bluffs, or 11 miles to Mount LeConte). The bluffs section passes under an arching rock overhang and through rhododendron tunnels — stunning in any season.
            </p>

            <h2>Day 3 — Cades Cove Wildlife Loop</h2>
            <p>
              Dedicate Day 3 to <strong>Cades Cove</strong>, an 11-mile one-way loop road through a broad mountain valley surrounded by peaks. This is the best place in the park for wildlife viewing: black bears, white-tailed deer, wild turkey, and coyotes are commonly spotted, especially at dawn and dusk. Historic 19th-century homesteads, grist mills, and churches line the loop.
            </p>
            <p>
              Wednesday and Saturday mornings the loop is open only to cyclists and walkers before 10am — worth planning around if you want to explore without traffic.
            </p>

            <h2>Day 4 — Cataloochee Valley & Elk Viewing</h2>
            <p>
              Cross into the North Carolina side to visit <strong>Cataloochee Valley</strong>, one of the park's least-visited and most rewarding areas. Elk were reintroduced here in 2001 and the herd now numbers over 200. Arrive at dawn or dusk for the best chance of seeing elk in the open meadows. Several historic structures — Palmer Chapel, Beech Grove School, Caldwell House — remain well-preserved in the valley. Head home from here via US-19 to Asheville or I-40 east.
            </p>

            <h2>Wildlife & Safety Tips</h2>
            <p>
              Black bears are common — the park has one of the highest densities of black bears in the eastern US. Stay 50 yards from bears, never feed them, and use bear-proof food storage. Carry bear spray. The park sees over 12 million visitors per year; arrive before 9am at popular trailheads to get parking.
            </p>

            <FAQAccordion
              title="Great Smoky Mountains FAQs"
              items={[
                { q: 'Is there an entrance fee for Great Smoky Mountains?', a: 'No — Great Smoky Mountains is one of the few national parks with no entry fee, thanks to a deed restriction from when the park was established in 1934.' },
                { q: 'When is the best time to visit Great Smoky Mountains?', a: 'April–June for wildflowers and spring color; October for peak fall foliage. Summer (July–August) is the busiest period with heavy traffic. Avoid holiday weekends if possible.' },
                { q: 'Are there bears in Great Smoky Mountains?', a: 'Yes — the park is home to approximately 1,500 black bears. Keep 50 yards of distance, never feed them, and store food properly. Bear encounters are common on popular trails.' },
                { q: 'Do you need a permit to hike in the Smokies?', a: 'Most day hikes are permit-free. Backcountry camping requires a permit ($4/person/night) booked through the park reservation system.' },
                { q: 'What is the hardest hike in Great Smoky Mountains?', a: 'The Appalachian Trail traverse from Newfound Gap to Davenport Gap (31 miles) and the Mount LeConte via Alum Cave Trail (11 miles, 2,800 ft gain) are among the most challenging.' },
                { q: 'Can you see elk in Great Smoky Mountains?', a: 'Yes — the Cataloochee Valley on the North Carolina side is the best place. A herd of 200+ elk was reintroduced in 2001. Best viewing is at dawn and dusk.' },
                { q: 'Where should I stay near Great Smoky Mountains?', a: "Gatlinburg and Pigeon Forge on the Tennessee side are the main gateway towns. Cherokee, NC is quieter and closer to the Cataloochee Valley. LeConte Lodge inside the park requires a hike to access and books up a year in advance." },
              ]}
            />

          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default GreatSmokyMountainsInfo;
